import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {BulkPermissionsService} from "../services/bulk/bulk-permissions.service";
import {ContractService} from "../services/contracts/contract.service";

@Directive({
  selector: '[appHasBulkPermissionByContract]'
})
export class HasBulkPermissionByContractDirective {

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private bulkPermissionsService: BulkPermissionsService,
    private contractService: ContractService
  ) {
  }

  @Input() set appHasBulkPermissionByContract(contract: any) {
    let hasPermission = this.bulkPermissionsService.hasBulkActionPermission(contract);
    if (hasPermission) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      if (this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    }
  }
}
